var render = function render(){var _vm=this,_c=_vm._self._c;return _c('Tooltip',{attrs:{"content":_vm.contentVal,"placement":_vm.placementVal,"delay":_vm.delayVal,"theme":_vm.themeVal,"max-width":_vm.maxWidthVal,"transfer":_vm.transferVal}},[_c('Icon',{attrs:{"type":_vm.iconNameVal,"size":_vm.iconSizeVal,"color":_vm.iconColorVal}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }